<template>
  <div class="index" :style ="{width:width}">
    <!-- {{props}} -->
    <!-- 这是测试标题 -->
    <div >{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    width:{
      width:{
        type:String
      }
    }
  },
};
</script>
<style lang="less" scoped>
.index {
  cursor: pointer;
  position: relative;
  height:36px;
  width: 520px;
  background: url("../../../assets/images/pageHome/box_title.png") center/100%
    100%;
  color: #fff;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  div {
    position: absolute;
    top:9%;
    left:5%;
  }
}
</style>
